import React, { useEffect, useRef, useState } from 'react';
import Loader from 'components/CustomComponents/Loader';
import { retrieveData } from 'helpers/utils/Utils';
import { GetApiHeadersWithBearer, GetRequest } from 'network/NetworkUtils';
import { useDispatch, useSelector } from 'react-redux';
import { GET_MASTER_BILLERS, MODIFY_BILLER, MODIFY_RPPS_BILLER } from 'network/URLConstants';
import { STATUS_SUCCESS_CODE } from 'network/URLConstants';
import CustomDropdown from "../../../../../CustomComponents/CustomDropDown"
import CustomTextInput from "../../../../../CustomComponents/CustomtextInput"
import { useTranslation } from "react-i18next";
import Yellow from '../../../../../../assets/smi-kudzu-images/yellow.png'
import { handleAmountInputLimitTo2decimal } from 'utils';
import CustomDatePicker from 'components/CustomComponents/CustomDateInput';
import { PostRequest } from 'network/NetworkUtils';
import { formatDateYYYYMMDDFORSCH } from 'utils';
import enableArrow from '../../../../../../assets/smi-kudzu-images/enable_arrow.png'
import disableArrow from '../../../../../../assets/smi-kudzu-images/disable_arrow.png'

const ModifyBiller = ({ data, onCancel, frequency, modifyBiller, modifySubmitBiller, openSubmitPart, getStates, getCountries, setIsLoading: setParentLoading, onModifySuccess ,billerTypeToModify: billerTypeToModifyProp, onRequireModifyBiller2FA}) => {
    const accessToken = useSelector((state) => state.accessToken);
    const SelectedBillers = useSelector(state => state.selectedBillerType);
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const cards = useSelector(state => JSON.parse(state.userCards));
    const selectedItem = cards?.find(card => card.AccountTypeBit63 === 1);
    const dispatch = useDispatch()
    const { t } = useTranslation();
    const primaryAcc = useSelector(x => x.primaryAccount)
    // Don't use data?.FrequencyText in useState alone: on first render `data` is often still
    // undefined (API not finished), and useState initial value does NOT update when `data` arrives.
    const [selectedFrequency, setSelectedFrequency] = useState(null)
    const [enteredAmount, setEnteredAmount] = useState()
    const [oneTimeSelectedDate, setOneTimeSelectedDate] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const billPaymentsMetaData = useSelector(x => x.billPaymentsMetaData)
  
    const reduxBillerTypeToModify = useSelector(x => x.BillerType)
    const billerTypeToModify =
        billerTypeToModifyProp ?? data?.BillerType ?? reduxBillerTypeToModify

    const [isSubmitting, setIsSubmitting] = useState(false)


    const setLoading = (v) => {
        setIsSubmitting(v)
        setParentLoading?.(v)
    }





    const [billerNameError, setBillerNameError] = useState('')
    const [billerName, setBillerName] = useState()
    const [enteredAccNumber, setEnteredAccountNumber] = useState()
    const [reEnteredAccNumber, setReEnteredAccNumber] = useState()
    const [enteredAccErr, setEnteredAccErr] = useState('');
    const [reEnterErrMesg, setReEnterErrMsg] = useState('')
    const [address1, setAddress1] = useState()
    const [address1ErrMsg, setAddress1ErrMsg] = useState('')
    const [address2, setAddress2] = useState()
    const [address2ErrMsg, setAddressErrMsg] = useState('')
    const [city, setCity] = useState()
    const [cityErrMsg, setCityErrMsg] = useState('')
    const [zipCode, setZipCode] = useState()
    const [zipErrMsg, setZipErrMsg] = useState('')
    const [selectedStates, setSelectedStates] = useState()
    const [selectedCountrie, setSelectedCountrie] = useState()
    const [phoneNumber, setPhoneNumbers] = useState()



    // Step 1 — Next disabled until required fields + matching account numbers (Address 2 optional)
    const hasBillerName = (billerName ?? '').trim().length > 0
    const hasAccountNumber = (enteredAccNumber ?? '').trim().length > 0
    const hasReEnteredAccountNumber = (reEnteredAccNumber ?? '').trim().length > 0
    const accountNumbersMatch =
        hasAccountNumber &&
        hasReEnteredAccountNumber &&
        (enteredAccNumber ?? '').trim() === (reEnteredAccNumber ?? '').trim()
    const hasAddress1 = (address1 ?? '').trim().length > 0
    const hasCity = (city ?? '').trim().length > 0
    const hasState = selectedStates != null && Object.keys(selectedStates || {}).length > 0
    const hasZip = (zipCode ?? '').toString().trim().length === 5
    const hasCountry = selectedCountrie != null && Object.keys(selectedCountrie || {}).length > 0
    const phoneDigitsOnly = (phoneNumber ?? '').toString().replace(/\D/g, '')
    const hasPhone = phoneDigitsOnly.length === 10
    const isNextDisabled =
        !hasBillerName ||
        !hasAccountNumber ||
        !hasReEnteredAccountNumber ||
        !accountNumbersMatch ||
        !hasAddress1 ||
        !hasCity ||
        !hasState ||
        !hasZip ||
        !hasCountry ||
        !hasPhone


    // Step 2 — Submit disabled until frequency, amount, dates
    const hasFrequency = selectedFrequency != null && Object.keys(selectedFrequency || {}).length > 0
    const amountNum = parseFloat(String(enteredAmount ?? '').replace(/[$,]/g, ''))
    const hasAmount = !Number.isNaN(amountNum) && amountNum > 0
    const hasStep2Dates =
        selectedFrequency?.Type === 'O'
            ? Boolean(oneTimeSelectedDate)
            : Boolean(startDate && endDate)
    const isSubmitDisabled =
        !hasFrequency || !hasAmount || !hasStep2Dates || isSubmitting

    /** API returns sentinel dates like 9999-12-31 for "no date" */
    const parseBillDateFromApi = (value) => {
        if (value == null || value === '') return null;
        const d = new Date(value);
        if (Number.isNaN(d.getTime())) return null;
        if (d.getFullYear() >= 9999) return null;
        return d;
    };


    const onDateChange = (date, type) => {
        if (type == 'oneTime') {
            setOneTimeSelectedDate(date)
               dispatch({ type: 'MODIFY_ONE_TIME_DATE', payload: { modifyOneTimeDate: date } })
        } else if (type == 'recurringStartDate') {
            setStartDate(date)
            dispatch({ type: 'MODIFY_START_DATE', payload: { modifyStartDate: date } })
            setEndDate(null)
            dispatch({ type: 'MODIFY_END_DATE', payload: { modifyEndDate: null } })
        } else if (type == 'recurringEndDate') {
            setEndDate(date)
            dispatch({ type: 'MODIFY_END_DATE', payload: { modifyEndDate: date } })
        }
    }

    // End date must be at least the day after start date
    const endDateMinDate = startDate ? (() => {
        const d = new Date(startDate);
        d.setDate(d.getDate() + 1);
        return d;
    })() : undefined;

    // Sync bill amount from API when `data` loads (same pattern as frequency)
    useEffect(() => {
        if (data == null || data.Amount === undefined || data.Amount === null) return
        const n = Number(data.Amount)
        if (Number.isNaN(n)) return
        const normalizedAmount = handleAmountInputLimitTo2decimal(String(n))
        setEnteredAmount(normalizedAmount)
        dispatch({ type: 'MODIFY_AMOUNT', payload: { modifyAmount: normalizedAmount } })
    }, [data])

       useEffect(() => {
        if (!data || !Array.isArray(frequency) || frequency.length === 0) return
        // API puts fields on `Response` — parent passes `responseObj.Response` as `data`
        const typeCode = data.FrequencyType
        const byType = frequency.find((f) => f?.Type === typeCode)
        if (byType) {
            setSelectedFrequency(byType)
            dispatch({ type: 'MODIFY_FREQUENCY', payload: { modifyFrequency: byType } })
            return
        }
        // Fallback: match by display text (e.g. "One-time")
        const text = data.FrequencyText
        if (text) {
            const byName = frequency.find((f) => f?.Name === text || f?.DisplayText === text)
            if (byName) {
                setSelectedFrequency(byName)
                dispatch({ type: 'MODIFY_FREQUENCY', payload: { modifyFrequency: byName } })
            }
        }
    }, [data, frequency])

    



    // // NextDate / EndDate from API when `data` loads (same async timing as amount & frequency)
    // useEffect(() => {
    //     if (!data) return
    //     const next = parseBillDateFromApi(data.NextDate)
    //     const end = parseBillDateFromApi(data.EndDate)
    //     const isOneTime = data.FrequencyType === 'O'
    //     if (isOneTime) {
    //         setOneTimeSelectedDate(next || '')
    //         setStartDate('')
    //         setEndDate('')
    //         dispatch({ type: 'MODIFY_ONE_TIME_DATE', payload: { modifyOneTimeDate: next ?? null } })
    //         dispatch({ type: 'MODIFY_START_DATE', payload: { modifyStartDate: null } })
    //         dispatch({ type: 'MODIFY_END_DATE', payload: { modifyEndDate: null } })
    //     } else {
    //         setStartDate(next || '')
    //         setEndDate(end || '')
    //         setOneTimeSelectedDate('')
    //         dispatch({ type: 'MODIFY_ONE_TIME_DATE', payload: { modifyOneTimeDate: null } })
    //         dispatch({ type: 'MODIFY_START_DATE', payload: { modifyStartDate: next ?? null } })
    //         dispatch({ type: 'MODIFY_END_DATE', payload: { modifyEndDate: end ?? null } })
    //     }
    // }, [data])




    // Pre-fill first step (modifyBiller) from API: name, account, address, phone, state, country
    useEffect(() => {
        if (!data) return
        const addr = data.BillerAddress || {}


        setBillerName(data.BillerName ?? '')


        const acc = data.AccountNumber != null ? String(data.AccountNumber) : ''
        setEnteredAccountNumber(acc)
        setReEnteredAccNumber(acc)
        setReEnterErrMsg('')
        const svaKey = data?.SVABillerKey ?? "";

   
        // Sync modify-specific redux fields (used by parent generate2FAOtp for modify)
        dispatch({ type: 'MODIFY_BILLER_NAME', payload: { modifyBillerName: data.BillerName ?? '' } })
        dispatch({ type: 'MODIFY_ACC_NUMBER', payload: { modifyAccNumber: acc } })
        dispatch({ type: 'MODIFY_SVA_BILLER_KEY', payload: { modifySvaBillerKey: svaKey } })

        setAddress1(addr.Line1 ?? '')
        setAddress2(addr.Line2 ?? '')
        dispatch({ type: 'MODIFY_LINE_ONE', payload: { modifyLine1: addr.Line1 ?? '' } })
        dispatch({ type: 'MODIFY_LINE_TWO', payload: { modifyLine2: addr.Line2 ?? '' } })


        setCity(addr.City ?? '')
        dispatch({ type: 'MODIFY_CITY', payload: { modifyCity: addr.City ?? '' } })



        const zip = addr.ZipCode != null && addr.ZipCode !== '' ? String(addr.ZipCode).replace(/\D/g, '').slice(0, 5) : ''
        setZipCode(zip)
        dispatch({ type: 'MODIFY_ZIPCODE', payload: { modifyZipCode: zip } })



        const phoneRaw = data.PhoneNumber != null ? String(data.PhoneNumber) : ''
        const phoneDigits = phoneRaw.replace(/\D/g, '').slice(0, 10)
        setPhoneNumbers(phoneDigits)
        dispatch({ type: 'MODIFY_PHONE', payload: { modifyPhone: phoneDigits } })



        const statesList = getStates || []
        if (statesList.length > 0) {
            const stateCode = addr.StateCode
            const stateName = addr.State
            const matchedState = statesList.find(
                (s) => s?.Type === stateCode || s?.Name === stateName
            )
            if (matchedState) {
                setSelectedStates(matchedState)
                dispatch({ type: 'MODIFY_STATES', payload: { modifyStates: matchedState } })
            }
        }



        const countriesList = getCountries || []
        if (countriesList.length > 0) {
            const countryCode = addr.CountryCode
            const countryName = addr.Country
            const matchedCountry = countriesList.find(
                (c) => c?.Type === countryCode || c?.Name === countryName
            )
            if (matchedCountry) {
                setSelectedCountrie(matchedCountry)
                dispatch({ type: 'MODIFY_COUNTRY', payload: { modifyCountry: matchedCountry } })
            }
        }
    }, [data, getStates, getCountries])





  const twoFactAuthenticationDone = useSelector(state => state.twoFactAuthenticationDone);
 const submitModifyBillerRequest = async () => {
        if (isSubmitDisabled || !selectedItem?.CardKey || !data?.SVABillerKey) return

              // If 2FA is not completed yet, do not call modify APIs.
        // Instead, open 2FA selection in the parent component.
        if (!twoFactAuthenticationDone) {
            onRequireModifyBiller2FA?.(billerTypeToModify === "P")
            return
        }

        setLoading(true)
        const freqType = selectedFrequency?.Type
        const nextDateValue =
            freqType === 'O' ? oneTimeSelectedDate : startDate
        const endDateValue =
            freqType === 'O' ? oneTimeSelectedDate : endDate

        const body = {
            AccountNumber: (enteredAccNumber ?? '').trim(),
            Amount: amountNum,
            BillerName: (billerName ?? '').trim(),
            City: (city ?? '').trim(),
            CountryCode: selectedCountrie?.Type ?? '',
            FrequencyType: freqType ?? '',
            Line1: (address1 ?? '').trim(),
            Line2: (address2 ?? '').trim() || '',
            NextDate: formatDateYYYYMMDDFORSCH(nextDateValue),
            PhoneNumber: phoneDigitsOnly,
            SVABillerKey: data.SVABillerKey,
            BillerID: data.BillerID ?? '',
            StateCode: selectedStates?.Type ?? '',
            ZipCode: (zipCode ?? '').toString().trim(),
            EndDate: formatDateYYYYMMDDFORSCH(endDateValue),
        }

     const rppsBody = {
         AccountNumber: (enteredAccNumber ?? '').trim(),
         Amount: amountNum,
         BillerName: (billerName ?? '').trim(),
         FrequencyType: freqType ?? '',
         NextDate: formatDateYYYYMMDDFORSCH(nextDateValue),
         EndDate: formatDateYYYYMMDDFORSCH(endDateValue),
         SVABillerKey: data.SVABillerKey,
         BillerID: data.BillerID ?? ''
     }


        const deviceId = await retrieveData('updatedDeviceId')
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken)
        const url = billerTypeToModify === "P" ?  MODIFY_BILLER(selectedItem?.CardKey) : MODIFY_RPPS_BILLER(selectedItem?.CardKey)
        try {
          const response = await PostRequest(url,billerTypeToModify === "P" ?  body : rppsBody, headers)
            const responseJson = JSON.parse(response)
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                setLoading(false)
                onModifySuccess?.(responseJson)
            } else {
                onModifySuccess?.(responseJson)
                const arrMessages = responseJson.Messages
                const message = arrMessages?.[0]
                const displayText = message?.DisplayText
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
        }
    }

    


   
    return (
        <>
            <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%]
                            animate__animated animate__fadeInRight '>
                <div className='md:w-[100%] sm:w-[100%] w-full '>

                    {(modifyBiller && billerTypeToModify === "P") &&
                        <>
                            <div className={`flex flex-col sm:mx-0 mx-4`}>
                                {!kudzuPlusTrue && (
                                    <hr className="w-[80%] mx-auto border-2 border-t border-[#A3CEBB]" />
                                )}
                                <div className='md:w-[80%] sm:w-[80%] w-[80%] mx-auto mt-6'>
                                    <p className={`text-start sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                                            sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px]
                                            sm:mx-0 mx-4 ${kudzuPlusTrue ? "text-white" : ""}`}>{(t('MODIFY_BILLER'))}</p>
                                </div>

                                <div className='flex justify-center'>
                                    <div className='md:w-[60%] sm:w-[60%] w-[60%] md:pt-6 pt-10 '>
                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Biller Name")}</p>
                                            <CustomTextInput

                                                onChange={(event) => {
                                                    const inputValue = event.target.value;
                                                    setBillerName(inputValue)
                                                    if (inputValue.length <= 50) {
                                                        dispatch({ type: 'MODIFY_BILLER_NAME', payload: { modifyBillerName: inputValue } });
                                                    } else {
                                                        console.log('Input length exceeds 50 characters');
                                                    }
                                                }}
                                                // onBlur={(event) => handleOnBlur(event)}
                                                value={billerName ? `${billerName}` : ''}
                                                // error={billerNameError}
                                                //placeholder={"First name"}
                                                inputWidth={`w-full`}
                                                autoFocus={true}
                                                readOnly={true}
                                            />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Biller Account Number")}</p>


                                            <CustomTextInput
                                                maxLength={35}
                                                autoFocus={true}
                                                onChange={(event) => {
                                                    const value = event.target.value;
                                                    setEnteredAccountNumber(value);
                                                    dispatch({ type: 'MODIFY_ACC_NUMBER', payload: { modifyAccNumber: value } });
                                                    // Live-validate match with re-entered account number
                                                    if ((reEnteredAccNumber ?? '').length > 0) {
                                                        if (value !== reEnteredAccNumber) {
                                                            setReEnterErrMsg('Account numbers do not match');
                                                        } else {
                                                            setReEnterErrMsg('');
                                                        }
                                                    }
                                                }}

                                                // onBlur={(e) => handleOnBlurEnteredAccountNumberInfo(e)}
                                                disallowSpaces={true}
                                                numbersOnly={true}
                                                value={enteredAccNumber}
                                                style={{ width: '100%', height: '51px' }}
                                                 readOnly={true}
                                            //error={enteredAccErr}
                                            />
                                        </div>
                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                                                           sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                                                     ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("RE_ENTERED_BILLER_ACC_NUMBER")}</p>
                                            <CustomTextInput
                                                maxLength={35}
                                                autoFocus={true}
                                                onChange={(event) => {
                                                    const value = event.target.value;
                                                    setReEnteredAccNumber(value);
                                                    // Live-validate match with first account number
                                                    if ((enteredAccNumber ?? '').length > 0) {
                                                        if (value !== enteredAccNumber) {
                                                            setReEnterErrMsg('Account numbers do not match');
                                                        } else {
                                                            setReEnterErrMsg('');
                                                        }
                                                    } else {
                                                        // If first field is empty, clear mismatch error and rely on required validation if any
                                                        setReEnterErrMsg('');
                                                    }
                                                }}

                                                // onBlur={(e) => handleOnBlurRe_EnteredAccountNumberInfo(e)}
                                                disallowSpaces={true}
                                                numbersOnly={true}
                                                value={reEnteredAccNumber}
                                                style={{ width: '100%', height: '51px' }}
                                                error={reEnterErrMesg}
                                                readOnly={true}
                                            />
                                        </div>
                                        <div className="mb-8 bg-[#DAE2E8] rounded-lg px-4 py-3 flex items-center gap-3">
                                            <img src={Yellow} alt="warning" className="w-5 h-5 shrink-0" />
                                            <p className="font-hanken-grotesk font-[600] text-[14px] leading-[20px] text-[#1E1E1E]">
                                                {t("BILL_PAYMENTS_BOTH_ACCOUNT_NUMBERS_SHOULD_MATCH")}
                                            </p>
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                                                           sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                                                     ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Address 1")}</p>
                                            <CustomTextInput

                                                onChange={(event) => {
                                                    const inputValue = event.target.value;
                                                    setAddress1(inputValue)
                                                    dispatch({ type: 'MODIFY_LINE_ONE', payload: { modifyLine1: inputValue } });
                                                }}
                                                // onBlur={(event) => handleOnBlur(event)}
                                                value={address1 ? `${address1}` : ''}
                                                // error={billerNameError}
                                                //placeholder={"First name"}
                                                inputWidth={`w-full`}
                                                autoFocus={true}
                                            />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                                                           sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                                                     ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Address 2")}</p>
                                            <CustomTextInput
                                                onChange={(event) => {
                                                    const inputValue = event.target.value;
                                                    setAddress2(inputValue)
                                                    dispatch({ type: 'MODIFY_LINE_TWO', payload: { modifyLine2: inputValue } });
                                                }}
                                                // onBlur={(event) => handleOnBlur(event)}
                                                value={address2 ? `${address2}` : ''}
                                                // error={billerNameError}
                                                //placeholder={"First name"}
                                                inputWidth={`w-full`}
                                                autoFocus={true}
                                            />
                                        </div>
                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                                                           sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                                                     ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("CITY")}</p>
                                            <CustomTextInput
                                                onChange={(event) => {
                                                    const inputValue = event.target.value;
                                                    setCity(inputValue)
                                                    dispatch({ type: 'MODIFY_CITY', payload: { modifyCity: inputValue } });
                                                }}
                                                // onBlur={(event) => handleOnBlur(event)}
                                                value={city ? `${city}` : ''}
                                                // error={billerNameError}
                                                //placeholder={"First name"}
                                                inputWidth={`w-full`}
                                                autoFocus={true}
                                            />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("STATE")}</p>
                                            <CustomDropdown
                                                options={getStates || []}
                                                onSelect={(option) => {
                                                    setSelectedStates(option)
                                                    dispatch({ type: 'MODIFY_STATES', payload: { modifyStates: option } });
                                                }}
                                                selectedAccountType={selectedStates}
                                            />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("ZIP CODE")}</p>
                                            <CustomTextInput
                                                maxLength={5}
                                                autoFocus={true}
                                                onChange={(event) => {
                                                    const value = event.target.value;
                                                    setZipCode(value);
                                                    dispatch({ type: 'MODIFY_ZIPCODE', payload: { modifyZipCode: value } });
                                                }}

                                                // onBlur={(e) => handleOnBlurEnteredAccountNumberInfo(e)}
                                                disallowSpaces={true}
                                                numbersOnly={true}
                                                value={zipCode}
                                                style={{ width: '100%', height: '51px' }}
                                            //error={enteredAccErr}
                                            />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Country")}</p>
                                            <CustomDropdown
                                                options={getCountries || []}
                                                onSelect={(option) => {
                                                    setSelectedCountrie(option)
                                                    dispatch({ type: 'MODIFY_COUNTRY', payload: { modifyCountry: option } });
                                                }}
                                                selectedAccountType={selectedCountrie}
                                            />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Phone Number")}</p>
                                            <CustomTextInput
                                                maxLength={10}
                                                autoFocus={true}
                                                onChange={(event) => {
                                                    const value = event.target.value;
                                                    setPhoneNumbers(value);
                                                    dispatch({ type: 'MODIFY_PHONE', payload: { modifyPhone: value } });
                                                }}

                                                // onBlur={(e) => handleOnBlurEnteredAccountNumberInfo(e)}
                                                disallowSpaces={true}
                                                numbersOnly={true}
                                                value={phoneNumber}
                                                style={{ width: '100%', height: '51px' }}
                                            //error={enteredAccErr}
                                            />

                                        </div>
                                    </div>
                                </div>

                                <div className='flex flex-row sm:justify-end w-[85%] justify-between mb-16'>
                                    <button
                                        onClick={onCancel}
                                        className='font-hanken-grotesk
                                    text-[var(--btn-clr-cards)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px]
                                    text-[16px]'>{t("Cancel")}</button>
                                    <button
                                        onClick={openSubmitPart}
                                         disabled={isNextDisabled}
                                        className={`font-hanken-grotesk text-[var(--input-text)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] sm:ml-10 ${isNextDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    >
                                        {t("Next")}
                                    </button>
                                     <img src={isNextDisabled ? disableArrow : enableArrow} alt="arrow" className='h-[13px] w-[13px] ml-3 mt-2 mb-2
                                                                                              sm:h-[10px] sm:w-[11px] md:h-[12px] md:w-[13px]' />
                                </div>
                            </div>
                        </>
                    }

                    {(modifySubmitBiller  || billerTypeToModify !== "P")&&
                        <>
                            <div className={`flex flex-col sm:mx-0 mx-4`}>
                                {!kudzuPlusTrue && (
                                    <hr className="w-[80%] mx-auto border-2 border-t border-[#A3CEBB]" />
                                )}
                                <div className='md:w-[80%] sm:w-[80%] w-[80%] mx-auto mt-6'>
                                    <p className={`text-start sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                                            sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px]
                                            sm:mx-0 mx-4 ${kudzuPlusTrue ? "text-white" : ""}`}>{(t('MODIFY_BILLER'))}</p>
                                </div>
                                <div className='flex justify-center'>
                                    <div className='md:w-[60%] sm:w-[60%] w-[60%] md:pt-6 pt-10 '>

                                        <div className='mb-8'>
                                            {/* <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("FROM")}</p> */}
                                            <CustomDropdown
                                                title={t('FROM')}
                                                hideArrow={true}
                                                selectedAccountType={primaryAcc}
                                                hrbg='bg-dropdown-sky'
                                                balanceFontColor={kudzuPlusTrue ? 'text-[#ffffff]' :'text-[#559C7E]'} />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Frequency")}</p>
                                            <CustomDropdown
                                                options={frequency || []}
                                                onSelect={(option) => {
                                                    setSelectedFrequency(option)
                                                      dispatch({ type: 'MODIFY_FREQUENCY', payload: { modifyFrequency: option } });
                                                }}
                                                selectedAccountType={selectedFrequency}
                                            />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Bill Amount")}</p>
                                            <CustomTextInput
                                                onChange={(event) => {
                                                    const inputValue = event.target.value;
                                                    const formattedAmount = handleAmountInputLimitTo2decimal(inputValue)
                                                    setEnteredAmount(formattedAmount)
                                                     dispatch({ type: 'MODIFY_AMOUNT', payload: { modifyAmount: formattedAmount } });
                                                }}
                                                value={enteredAmount ? `$${enteredAmount}` : ''}
                                                placeholder={"$ 0"}
                                                inputWidth='w-full'
                                            />
                                        </div>

                                        <div className='mb-8'>

                                            {selectedFrequency?.Type === "O" &&
                                                <CustomDatePicker
                                                    selectedDate={oneTimeSelectedDate}
                                                    onDateChange={(date) => onDateChange(date, 'oneTime')}
                                                    minDate={new Date(new Date().toUTCString().substr(0, 25))}
                                                    maxDate={billPaymentsMetaData?.EndDate}
                                                    disabledDates={[]}
                                                    title="Next Payment DATE"
                                                    hrbg="bg-dropdown-sky"
                                                    placeHolder={t('Month_Day_Year')}
                                                />
                                            }
                                        </div>
                                        <div className='mb-8'>
                                            {selectedFrequency?.Type !== "O" &&
                                                <CustomDatePicker
                                                    selectedDate={startDate}
                                                    onDateChange={(date) => onDateChange(date, 'recurringStartDate')}
                                                    minDate={new Date(new Date().toUTCString().substr(0, 25))}
                                                    maxDate={billPaymentsMetaData?.EndDate}
                                                    title="Next Payment DATE"
                                                    hrbg='bg-dropdown-sky'
                                                    disabledDates={[]}
                                                    placeHolder={t('Month_Day_Year')}
                                                />
                                            }

                                        </div>
                                        <div className='mb-12'>
                                            {selectedFrequency?.Type !== "O" &&
                                                <CustomDatePicker
                                                    selectedDate={endDate}
                                                    onDateChange={(date) => onDateChange(date, 'recurringEndDate')}
                                                    minDate={endDateMinDate}
                                                    maxDate={billPaymentsMetaData?.EndDate}
                                                    disabledDates={[]}
                                                    title="End Date"
                                                    hrbg='bg-dropdown-sky'
                                                    placeHolder={t('Month_Day_Year')}
                                                />
                                            }
                                        </div>

                                        <div className='flex flex-col gap-4 justify-center items-center w-full mb-20'>
                                            <button
                                                onClick={submitModifyBillerRequest}
                                                disabled={isSubmitDisabled}
                                                class={`font-hanken-grotesk lg:text-[18px] md:text-[17px]
                                   sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] text-white  border-2 px-2 py-4 border-[#2965FB] w-full ${isSubmitDisabled ? 'bg-[#94C3E8] border-[#94C3E8] cursor-not-allowed' : "bg-[#2965FB] border-[#2965FB] cursor-pointer"}`}
                                            >{t("Submit")}</button>

                                            <button className='focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[] text-[#2965FB] cursor-pointer  px-2 py-4 border-[#4B70B9] w-full'
                                                onClick={onCancel}
                                            >{t("Cancel")}</button>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </>
                    }

                </div>
            </div>
        </>
    )
}
export default ModifyBiller;